import { Button, Container, Typography, Box, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import SentimentDissatisfiedRoundedIcon from "@mui/icons-material/SentimentDissatisfiedRounded";
// import notFound from "../assets/img/notFound.png";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
        background:
          "linear-gradient(180deg, rgba(245,247,251,0.95) 0%, rgba(236,242,248,0.98) 100%)",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.2, sm: 3.5, md: 4.5 },
            borderRadius: { xs: 4, md: 5 },
            border: "1px solid rgba(0,0,0,0.08)",
            background: "rgba(255,255,255,0.72)",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            boxShadow: "0 18px 50px rgba(0,0,0,0.08)",
            textAlign: "center",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: 3,
              mx: "auto",
              mb: 2,
              display: "grid",
              placeItems: "center",
              bgcolor: "rgba(25,118,210,0.10)",
              color: "primary.main",
              border: "1px solid rgba(25,118,210,0.18)",
            }}
          >
            <SentimentDissatisfiedRoundedIcon sx={{ fontSize: 32 }} />
          </Box>

          {/* <Box
            component="img"
            src={notFound}
            alt="Página no encontrada"
            sx={{
              width: { xs: 180, sm: 220, md: 260 },
              maxWidth: "100%",
              height: "auto",
              mb: 2.5,
              userSelect: "none",
              pointerEvents: "none",
            }}
          /> */}

          <Typography
            sx={{
              fontSize: { xs: 30, sm: 40 },
              fontWeight: 950,
              lineHeight: 1,
              mb: 1,
              color: "primary.main",
              letterSpacing: -1,
            }}
          >
            404
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 22, sm: 28 },
              fontWeight: 900,
              mb: 1,
              lineHeight: 1.15,
            }}
          >
            Página no encontrada
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              maxWidth: 520,
              mx: "auto",
              mb: 3,
              opacity: 0.82,
            }}
          >
            La página que intentaste abrir no existe, fue movida o no tenés
            acceso a esa ruta.
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 1.2,
              justifyContent: "center",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              variant="contained"
              startIcon={<HomeRoundedIcon />}
              onClick={() => navigate("/home")}
              sx={{
                borderRadius: 2.5,
                fontWeight: 900,
                textTransform: "none",
                px: 3,
                py: 1.2,
              }}
            >
              Ir al inicio
            </Button>

            <Button
              variant="outlined"
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 2.5,
                fontWeight: 800,
                textTransform: "none",
                px: 3,
                py: 1.2,
              }}
            >
              Volver atrás
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
